import { GoogleSignInButton, useAuth } from "../auth";
import { configError } from "../config";

export function Login({ error }: { error?: string }) {
  const { ready } = useAuth();
  const misconfigured = configError();

  return (
    <div className="centered">
      <div className="card login">
        <h1>Bean Admin</h1>
        <p className="muted">Sign in with your Bean Google account.</p>

        {misconfigured ? (
          <p className="error" role="alert">
            {misconfigured} Set it on the Cloud Run service (or in a local
            <code> public/config.js</code>) and reload.
          </p>
        ) : (
          <>
            <div className="signin-slot">
              {ready ? <GoogleSignInButton /> : <span className="muted">Loading…</span>}
            </div>
            {error && (
              <p className="error" role="alert">
                {error}
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
